/**
 * Base classes for the component.
 * @type {String}
 */
export const BASE_CLASS = 'orca-education-tooltip';

/**
 * Base container classes for the component.
 * @type {String}
 */
export const BASE_CONTAINER_CLASS = 'orca-education-tooltip-container';

/**
 * Base box classes for the component.
 * @type {String}
 */
export const BASE_BOX_CLASS = 'orca-education-tooltip-box';

/**
 * Base box content classes for the component.
 * @type {String}
 */
export const BASE_BOX_CONTENT_CLASS = 'orca-education-tooltip-box-content';
